import React from 'react';
import { ChevronLeft, LogOut } from 'lucide-react';

/**
 * NavAcciones — barra de navegación compacta con "Regresar" y "Salir"
 * Props:
 *   onRegresar  — función a llamar al presionar "Regresar" *   onSalir     — función a llamar al presionar"Salir"
 *   label       — (opcional) nombre de la sección actual
 */
const NavAcciones = ({ onRegresar, onSalir, label }) => {
  return (
    <div className="flex items-center justify-between gap-2 px-0 py-2 mb-4 border-b border-border">
      <button
        onClick={onRegresar}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors press-effect"
        aria-label="Regresar">

        <ChevronLeft className="w-4 h-4 flex-shrink-0" />
        <span>Regresa</span>
      </button>

      {label &&
      <span className="text-sm font-semibold text-foreground truncate hidden sm:block">{label}</span>
      }

      <button
        onClick={onSalir}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-destructive hover:bg-destructive/10 rounded-lg transition-colors press-effect"
        aria-label="Salir">

        <span>Salir</span>
        <LogOut className="w-4 h-4 flex-shrink-0" />
      </button>
    </div>);

};

export default NavAcciones;